var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NGXLogger } from 'ngx-logger';
import { AuthenticationService } from '../../service/authentication.service';
import { MessageService } from '../../service/message.service';
import { PageService } from '../../models/page.service';
import { ContentBaseComponent } from '../base/contentbase.component';
import { AuAction } from '../../action/au.action';
import { ConfigService } from '../../service/config.service';
var LoginComponent = /** @class */ (function (_super) {
    __extends(LoginComponent, _super);
    function LoginComponent(router, route, logger, action, message, page, authenticationService, config) {
        var _this = _super.call(this, router, route, logger, action, message, page, authenticationService) || this;
        _this.router = router;
        _this.route = route;
        _this.logger = logger;
        _this.action = action;
        _this.message = message;
        _this.page = page;
        _this.authenticationService = authenticationService;
        _this.config = config;
        _this.componentName = LoginComponent.name;
        _this.model = {};
        _this.loading = false;
        _this.error = false;
        _this.logo = _this.config.config['login_logo'] || '';
        _this.buildNo = _this.config.config['build'] || '';
        _this.buildNoInfo = _this.config.config['build_info'] || ''; // 'hide' or 'show'
        _this.awsEnvironment = _this.config.config['aws_environment'];
        return _this;
    }
    LoginComponent.prototype.ngOnInit = function () {
        var _this = this;
        _super.prototype.ngOnInit.call(this);
        this.routeSubscription = this.route.data.subscribe(function (data) {
            var _params = {};
            _this.route.params.subscribe(function (params) {
                _params = Object.assign({}, params);
            });
            _this.action.setInit(_params, data.meta, _this.msgSnapshot);
        });
    };
    LoginComponent.prototype.onInit = function (meta) {
        _super.prototype.onInit.call(this, meta);
        if (meta.events) {
            this.action.setEvents(meta.events);
        }
    };
    LoginComponent.prototype.setUnsubscribe = function () {
        this.eventSubscription.unsubscribe();
        this.refSubscription.unsubscribe();
        this.modeSubscription.unsubscribe();
        this.changeSubscription.unsubscribe();
    };
    LoginComponent.prototype.login = function () {
        var _this = this;
        if (this.loading) {
            return;
        }
        this.loading = true;
        this.authenticationService.login(this.model.id, this.model.password)
            .subscribe(function (data) {
            if (data === null) {
                return;
            }
            // get return url from route parameters or default to '/'
            _this.returnUrl = _this.route.snapshot.params['returnUrl'] || '/top';
            if (_this.returnUrl === '/password') {
                _this.returnUrl = '/top';
            }
            _this.router.navigate([_this.returnUrl], { queryParams: _this.route.snapshot.queryParams });
        }, function (error) {
            // if (!error.code) {
            //     alert(this.msgSnapshot['LoginComponent.error']);
            // }
            // this.alertService.error(error);
            _this.loading = false;
        });
    };
    LoginComponent.prototype.onEvent = function (e1, e2) {
        if (e2 === 'reissue') {
            if (!this.model.id) {
                this.error = true;
            }
            else {
                this.action.setRec({ login: this.model.id });
                this.action.firstAction(e2);
            }
        }
    };
    LoginComponent.prototype.ngOnDestroy = function () {
        _super.prototype.ngOnDestroy.call(this);
        this.routeSubscription.unsubscribe();
    };
    LoginComponent.decorators = [
        { type: Component, args: [{
                    moduleId: module.id.toString(),
                    template: "<alertblock></alertblock>\n<div class=\"l-login\">\n  <header class=\"loginHeader\">\n    <ul class=\"hNav\">\n      <li class=\"hNav_li hNav_accountMenu\">\n        <div class=\"hNav_user\">\n          <p class=\"hNav_user_lang\">\n            <language [saveDefaultLang]=\"false\"></language>\n          </p>\n        </div>\n      </li>\n    </ul>\n  </header>\n  <main role=\"main\" class=\"main\">\n    <div class=\"login\">\n      <p><img [src]=\"logo\" alt=\"\" width=\"220\"></p>\n      <p *ngIf=\"awsEnvironment==='staging'\" class=\"login_attention\" [innerHTML]=\"(msg | async)['au.COMPONENTS.label.environment_attention_login']\"></p>\n      <p *ngIf=\"buildNoInfo === 'show'\" class=\"-mt-1\">(Rev. {{ buildNo }})</p>\n      <form class=\"login_form\" (ngSubmit)=\"f.form.valid && login()\" #f=\"ngForm\" novalidate>\n        <dl>\n          <dt>\n            <label for=\"id\">{{ (msg | async)['LoginComponent.label.email'] }}</label>\n          </dt>\n          <dd>\n            <input type=\"email\" id=\"id\" name=\"id\" [(ngModel)]=\"model.id\" #id=\"ngModel\" required/>\n            <p *ngIf=\"(f.submitted || error) && !id.valid\" class=\"login_form_comment\">{{ (msg | async)['LoginComponent.error.email'] }}</p>\n          </dd>\n          <dt>\n            <label for=\"password\">{{ (msg | async)['LoginComponent.label.password'] }}</label>\n          </dt>\n          <dd>\n            <input type=\"password\" id=\"password\" name=\"password\" [(ngModel)]=\"model.password\" #password=\"ngModel\" required/>\n            <p *ngIf=\"f.submitted && !password.valid\" class=\"login_form_comment\">{{ (msg | async)['LoginComponent.error.password'] }}</p>\n          </dd>\n        </dl>\n        <button [disabled]=\"loading\" type=\"submit\">{{ (msg | async)['LoginComponent.button.login'] }}</button>\n        <p class=\"login_form_note\">{{ (msg | async)['LoginComponent.note.reissue'] }}</p>\n        <button type=\"button\" (click)=\"onEvent($event, 'reissue')\">{{ (msg | async)['LoginComponent.button.reissuePassword'] }}</button>\n      </form>\n      <div class=\"login_description\">\n        <div [innerHTML]=\"(msg | async)['LoginComponent.note.heading']\"></div>\n        <div class=\"login_description_listWrapper\" [innerHTML]=\"(msg | async)['LoginComponent.note']\"></div>\n      </div>\n    </div>\n  </main>\n  <pa-footer></pa-footer>\n</div><!-- /.l-login -->\n<loading></loading>\n",
                    styles: [""]
                }] }
    ];
    /** @nocollapse */
    LoginComponent.ctorParameters = function () { return [
        { type: Router },
        { type: ActivatedRoute },
        { type: NGXLogger },
        { type: AuAction },
        { type: MessageService },
        { type: PageService },
        { type: AuthenticationService },
        { type: ConfigService }
    ]; };
    return LoginComponent;
}(ContentBaseComponent));
export { LoginComponent };
//# sourceMappingURL=login.component.js.map